export enum AssetClass2 {
  ALTERNATIVE_FUND = "alternative_fund",
  ASIAN_STOCK = "asian_stock",
  BOND = "bond",
  BUYOUT = "buyout",
  CARREFOUR = "carrefour",
  CASH = "cash",
  DEBT_FUND = "debt_fund",
  DIRECT_PRIVATE_DEBT = "direct_private_debt",
  EMERGING_STOCK_FUND = "emerging_stock_fund",
  EUROPEAN_STOCK = "european_stock",
  EUROPEAN_STOCK_FUND = "european_stock_fund",
  FIXED_TERM_BOND = "fixed_term_bond",
  GP_STAKE = "gp_stake",
  GROWTH = "growth",
  LIVE_REAL_ESTATE = "live_real_estate",
  MONETARY_FUND = "monetary_fund",
  MULTI_ASSET_FUND = "multi_asset_fund",
  PERPETUAL_BOND = "perpetual_bond",
  RE_CORE_FUND = "re_core_fund",
  RE_VALUE_ADDED_FUND = "re_value_added_fund",
  SECONDARY = "secondary",
  STRUCTURED_NOTES_HOTTINGUER = "structured_notes_hottinguer",
  STRUTURED_NOTES_OTHER = "strutured_notes_other",
  TERM_ACCOUNT = "term_account",
  THAMEATICS_FUND = "thameatics_fund",
  UNALLOCATED_FEES = "unallocated_fees",
  US_STOCK = "us_stock",
  US_STOCK_FUND = "us_stock_fund",
  VENTURE = "venture",
  WORLD_STOCK_FUND = "world_stock_fund",
}
